const DRAFT_TABLE_TEMPLATE_SORTING = [
  'newRecipientTotal',
  'addedRecipient',
  'removedRecipient',
  'currentRecipient'
];
const LIVE_TABLE_TEMPLATE_SORTING = ['addedRecipient', 'newRecipientTotal'];

const AUTOMATION_TABLE_TEMPLATE_SORTING = [
  'newRecipientTotal',
  'addedRecipient',
  'currentRecipient'
];

const EDIT_RECIPIENT_STEP = 'editRecipient';
const REVIEW_AND_CONFIRM_STEP = 'reviewAndConfirm';

export {
  AUTOMATION_TABLE_TEMPLATE_SORTING,
  DRAFT_TABLE_TEMPLATE_SORTING,
  EDIT_RECIPIENT_STEP,
  LIVE_TABLE_TEMPLATE_SORTING,
  REVIEW_AND_CONFIRM_STEP
};
